import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  w100: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  root: {
    backgroundColor: "#f8f8f8",
    [theme.breakpoints.down("1100")]: {
      "& .buttons-container-responsive": {
        "& .row-responsive": {
          justifyContent: "flex-start",
          "& button": {
            width: 200,
          },
        },
      },
    },
    [theme.breakpoints.down("575")]: {
      width: "90%",
      margin: "0 auto",
      "& .buttons-container-responsive": {
        width: "auto",
        "& .row-responsive": {
          justifyContent: "center",
          "& button": {
            width: 200,
          },
        },
      },
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    "&.buttons-row": {
      marginTop: "190px",
      marginBottom: "86px",
    },
    [theme.breakpoints.down("575")]: {
      flexDirection: "column-reverse",
      gap: "30px",
    },
  },
  pageTitle: {
    color: "#202020",
    fontSize: "32px",
    lineHeight: "44px",
    fontWeight: "bold",
    marginBottom: "59px",
    width: "95%",
    maxWidth: "100%",
  },
  pageTitleResponsive: {
    color: "#202020",
    fontSize: "2rem",
    lineHeight: "44px",
    fontWeight: "bold",
    marginBottom: "59px",
    width: "95%",
    maxWidth: "100%",
    display: "none",
    [theme.breakpoints.down("991")]: {
      display: "block",
      textAlign: "center",
    },
    [theme.breakpoints.down("575")]: {
      fontSize: "1.5rem",
    },
  },
  leftPane: {
    width: "55%",
    [theme.breakpoints.down("1100")]: {
      width: "50%",
    },
    [theme.breakpoints.down("991")]: {
      width: "100%",
      "& .pageTitle": {
        display: "none",
      },
    },
  },
  rightPane: {
    width: "45%",
    [theme.breakpoints.down("991")]: {
      width: "100%",
    },
    [theme.breakpoints.down("575")]: {
      width: "90%",
      margin: "auto",
    },
  },
  formTitle: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "26px",
    color: "#202020",
    "& span": {
      color: "#245fad",
    },
  },
  spinnerWrapper: {
    height: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("767")]: {
      height: "250px",
    },
  },
  spinnerWrapperMain: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  countryCode: {
    width: "106px",
    maxWidth: "100%",
    height: "50px",
    border: "1px solid #9CA3AF",
    borderRadius: "10px",
    background: "#FFFFFF",
    marginRight: "11px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  phoneNumber: {
    width: "355px",
  },
  input: {
    background: "#FFFFFF",
    height: "50px",
    borderRadius: "10px!important",
    "&.Mui-error": {
      border: "1px solid red",
    },
  },
  autocomplete: {
    background: "#FFFFFF",
    height: "50px",
    borderRadius: "10px",
    "& .MuiFormControl-root": {
      height: "50px",
      "& label": {
        top: "-3px",
      },
      "& .MuiInputBase-root": {
        borderRadius: "10px",
        height: "100%",
        "& .MuiInputBase-input.MuiOutlinedInput-input.MuiAutocomplete-input": {
          padding: "4px!important",
        },
        "& .MuiAutocomplete-popupIndicator": {
          "& svg": {
            fill: "#245fad",
          },
        },
      },
      "& .MuiFormHelperText-root": {
        "&.Mui-error": {
          [theme.breakpoints.down("575")]: {
            fontSize: "0.65rem",
            marginTop: "-2px",
          },
          [theme.breakpoints.down("400")]: {
            fontSize: "0.50rem",
          },
        },
      },
    },
  },
  firstName: {
    width: "168px",
    maxWidth: "100%",
    marginRight: "10px",
    position: "relative",
  },
  lastName: {
    width: "291px",
    maxWidth: "100%",
    position: "relative",
  },
  box: {
    position: "relative",
  },
  errorMessage: {
    position: "absolute",
    right: "10px",
    bottom: "-20px",
    color: "#f44336",
    fontSize: "0.75rem",
    letterSpacing: "0.03333em",
    [theme.breakpoints.down("575")]: {
      fontSize: "0.65rem",
      bottom: "-12px",
    },
    [theme.breakpoints.down("400")]: {
      fontSize: "0.50rem",
    },
  },
  attentionTxtTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#222429",
    marginTop: 8,
  },
  attentionTxtSubTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#222429",
    marginTop: 20,
  },
  attentionIcon: {
    width: 60,
    height: 60,
  },
}));

export default useStyles;
